module.exports = __webpack_public_path__ + "img/XMR.ec4581f3.png";